import { StandardEvents } from '@shopify/events';
let refreshId = 0;
async function refreshShipping() {
 const id = ++refreshId;
 const first = document.querySelector('nf-free-shipping');
 if (!first) return;
 try {
  const response = await fetch(first.dataset.cartUrl, {credentials:'same-origin',cache:'no-store'});
  if (!response.ok) return;
  const cart = await response.json();
  if (id !== refreshId) return;
  document.querySelectorAll('nf-free-shipping').forEach(el => {
   if (cart.currency !== el.dataset.currency) return;
   const remaining = Math.max(0, Number(el.dataset.threshold) - cart.total_price);
   const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:cart.currency, currencyDisplay:'code', maximumFractionDigits:2}).format(remaining / 100);
   el.textContent = remaining > 0 ? el.dataset.remaining.replace('[amount]', amount) : el.dataset.unlocked;
  });
 } catch {}
}
const afterUpdate = event => Promise.resolve(event.promise).then(refreshShipping).catch(() => {});
for (const eventName of new Set(Object.entries(StandardEvents).filter(([key]) => key.toLowerCase().includes('cart') && key.toLowerCase().includes('update')).map(([, value]) => value))) {
 if (typeof eventName === 'string') document.addEventListener(eventName, afterUpdate);
}
window.addEventListener('pageshow', refreshShipping);
document.addEventListener('shopify:section:load', refreshShipping);
refreshShipping();
